import { useTranslation } from 'react-i18next';

import { getCodedAnnotationPresentation } from 'services/webediErrors/annotationPresentation';
import { WebEDIOcrVerificationWarning } from 'services/webediErrors/types';
import { WithRef } from 'support/types/withRef';

import { ActionsSection } from '../../components/ActionsSection';
import { EditDocumentButton } from '../../components/EditDocumentButton/EditDocumentButton';
import { NavigationFooter } from '../../components/NavigationFooter';
import { FieldAnnotationPopoverShell } from '../../FieldAnnotationPopoverShell';

type Props = {
  annotation: WebEDIOcrVerificationWarning;
  viewMode: boolean;
  style?: React.CSSProperties;
};

export const OcrVerificationWarning = ({ annotation, viewMode, ref, style }: WithRef<Props, HTMLDivElement>) => {
  const { t } = useTranslation();
  const message = annotation.currentValue.translatedMessage;
  const hasMessage = message.trim().length > 0;

  return (
    <FieldAnnotationPopoverShell
      ref={ref}
      style={style}
      status="warning"
      title={t(getCodedAnnotationPresentation(annotation).titleKey)}
      description={
        hasMessage ? (
          <span data-testid="ocr-verification-warning-body" className="whitespace-pre-wrap">
            {message}
          </span>
        ) : undefined
      }
      actions={
        <ActionsSection>
          <EditDocumentButton viewMode={viewMode} annotation={annotation} />
        </ActionsSection>
      }
      footer={<NavigationFooter />}
    />
  );
};

/**
 * i18n keys
 * t('webedi:fieldAnnotation.ocrVerificationWarning.title')
 */
